import { render, staticRenderFns } from "./DateButton.vue?vue&type=template&id=5809a187&scoped=true&"
import script from "./DateButton.vue?vue&type=script&lang=js&"
export * from "./DateButton.vue?vue&type=script&lang=js&"
import style0 from "./DateButton.vue?vue&type=style&index=0&id=5809a187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809a187",
  null
  
)

export default component.exports